import { render, staticRenderFns } from "./AccountTabs.vue?vue&type=template&id=ca9a2aca&scoped=true&"
import script from "./AccountTabs.vue?vue&type=script&lang=js&"
export * from "./AccountTabs.vue?vue&type=script&lang=js&"
import style0 from "./AccountTabs.vue?vue&type=style&index=0&id=ca9a2aca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9a2aca",
  null
  
)

export default component.exports